import React, { useEffect, useState } from "react";
import { Box, Typography, Button, Card, CardContent } from "@mui/material";
import { makeRequest } from "../../makeRequest";
import TrainerCard from "./TrainerCard";
import { useNavigate } from "react-router-dom";

const TrainerList = () => {
  const [trainers, setTrainers] = useState([]);
  const navigate = useNavigate();

  // Fetch trainers from the API
  const fetchTrainers = async () => {
    try {
      const response = await makeRequest.get("/trainers");
      const trainers = response.data;

      // Map over trainers and fetch the signed URL for each image
      const trainersWithImages = await Promise.all(
        trainers?.map(async (trainer) => {
          const updatedTrainer = { ...trainer };

          if (trainer.image) {
            try {
              // Fetch signed URL for the image
              const imageResponse = await makeRequest.get(
                `/images/${trainer.image}`
              );
              updatedTrainer.image = imageResponse.data.url; // Update trainer.image with the URL
            } catch (err) {
              console.error(
                `Error fetching image for trainer ${trainer.id}:`,
                err
              );
            }
          }

          if (trainer.image2) {
            try {
              // Fetch signed URL for the image2
              const image2Response = await makeRequest.get(
                `/images/${trainer.image2}`
              );
              updatedTrainer.image2 = image2Response.data.url; // Update trainer.image2 with the URL
            } catch (err) {
              console.error(
                `Error fetching image2 for trainer ${trainer.id}:`,
                err
              );
            }
          }

          return updatedTrainer; // Return the updated trainer object
        })
      );

      setTrainers(trainersWithImages);
    } catch (err) {
      console.error("Error fetching trainers:", err);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this user?")) {
      try {
        const response = await makeRequest.delete(`/trainers/${id}`);
        alert(response.data.message);
        fetchTrainers();
      } catch (error) {
        alert(error.response?.data?.error || "An error occurred");
      }
    }
  };

  useEffect(() => {
    fetchTrainers();
  }, []);

  return (
    <Box className="poppins" sx={{ p: 4 }}>
      <Button variant="contained" sx={{ my: 2 }} onClick={fetchTrainers}>
        Refresh List
      </Button>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
          gap: 2,
        }}
      >
        {trainers?.map((trainer) => (
          <Card
            key={trainer?._id}
            sx={{ display: "flex", flexDirection: "column" }}
          >
            <TrainerCard trainer={trainer} />
            <CardContent sx={{ height: "100%" }}>
              <Typography variant="h6">
                {trainer?.firstname} {trainer?.lastname}
              </Typography>
              <Typography variant="body2">
                <strong>Occupations:</strong> {trainer?.occupations.join(", ")}
              </Typography>
              <Typography variant="body2">
                <strong>Message:</strong>{" "}
                <div
                  dangerouslySetInnerHTML={{ __html: trainer?.message }}
                ></div>
              </Typography>
              {trainer?.instagram !== "" && (
                <Typography variant="body2">
                  <strong>Instagram:</strong>{" "}
                  <a
                    className="underline"
                    target="_blank"
                    href={trainer?.instagram}
                  >
                    Link
                  </a>
                </Typography>
              )}
              {trainer?.facebook !== "" && (
                <Typography variant="body2">
                  <strong>Facebook:</strong>{" "}
                  <a
                    className="underline"
                    target="_blank"
                    href={trainer?.facebook}
                  >
                    Link
                  </a>
                </Typography>
              )}
            </CardContent>
            <Button
              color="warning"
              sx={{ mb: 2 }}
              variant="contained"
              onClick={() => navigate(`/Trainerupdate/${trainer?._id}`)}
            >
              Update
            </Button>
            <Button
              color="error"
              variant="contained"
              onClick={(e) => handleDelete(trainer?._id)}
            >
              Delete User
            </Button>
          </Card>
        ))}
      </Box>
    </Box>
  );
};

export default TrainerList;
